export const getSwitchState = (state: boolean) => {
  return state ? "включено" : "выключено";
};
